export default {
  set_error(state, error) {
    state.errors = error;
  },
  clear_list(state) {
    state.prescriptions = [],
    state.totalCount = 0
  },
  set_prescriptions(state, {prescriptions}) {
    state.prescriptions = prescriptions.data;
    state.totalCount = prescriptions.total;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
